import { Box } from "@mui/material";
import { ReactNode } from "react";

export type PlanningLayoutProps = {
    children: ReactNode;
};

export const PlanningLayout = (props: PlanningLayoutProps) => {
    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "100%",
                overflow: "hidden",
                boxSizing: "border-box",
            }}
        >
            {props.children}
        </Box>
    );
};
